import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import SeeIdfa from '@/components/System/SubSys/SeeIdfa';
import SubSysEdit from '@/components/System/SubSys/SubSysEdit';
import SysEdit from '@/components/System/SubSys/SysEdit';
import delDialog from '@/components/System/DelDialog';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils';
import { filterSystemType } from '@/utils/filters.js';
export default {
  components: {
    SearchForm: SearchForm,
    SeeIdfa: SeeIdfa,
    SubSysEdit: SubSysEdit,
    SysEdit: SysEdit,
    delDialog: delDialog,
    NoData: NoData
  },
  filters: {
    filterSystemType: filterSystemType
  },
  data: function data() {
    return {
      delChecked: false,
      showIdfa: false,
      showSubSysEdit: false,
      showSysEdit: false,
      ifSysEdit: true,
      ifSubSysEdit: false,
      operationitem: null,
      systemtpyelist: [],
      selectsystem: null,
      systemidfa: '',
      delsystemlist: [],
      searchFormData: [{
        title: '查询类型',
        key: 'subsys',
        placeholder: '请选择系统名称/系统编号',
        type: 'select',
        selectData: [{
          label: '系统名称',
          value: '系统名称'
        }, {
          label: '系统编号',
          value: '系统编号'
        }],
        selectedArr: '系统名称',
        multiple: false
      }, {
        title: '查询条件',
        key: 'subsys',
        placeholder: '请输入系统编号或系统名称',
        type: 'input',
        value: null
      }],
      btnType: 'add, search,reset',
      systemlistparms: {
        pageNum: 1,
        pageSize: 10,
        systemId: '',
        systemName: ''
      },
      pageshow: true,
      tableData: [],
      totalpages: 0,
      multipleSelection: null,
      ifShowDelDialog: false,
      loading: false,
      isIndeterminate: false,
      tableheight: 0
    };
  },
  created: function created() {
    this.getsystemlist();
    this.getSystemType();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getsystemlist: function getsystemlist() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/systemInner/list',
        data: this.systemlistparms
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.tableData = res.result.records;
          _this.totalpages = res.result.total;
        }
      });
    },
    getSystemType: function getSystemType() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/getSystemType'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.systemtpyelist = res.result;
        }
      });
    },
    searchForm: function searchForm(obj) {
      if (obj[0].selectedArr === '系统名称') {
        this.systemlistparms.systemId = '';
        this.systemlistparms.systemName = obj[1].value;
      } else {
        this.systemlistparms.systemName = '';
        this.systemlistparms.systemId = obj[1].value;
      }
      this.systemlistparms.pageNum = 1;
      this.getsystemlist();
    },
    resetForm: function resetForm(obj) {
      this.searchFormData[0].selectedArr = '系统名称';
      this.searchFormData[1].value = '';
      this.systemlistparms.systemId = '';
      this.systemlistparms.systemName = obj[1].value;
      this.getsystemlist();
    },
    // changesearch(obj){
    //   if(obj[0].selectedArr == "系统名称"){
    //     this.systemlistparms.systemId = "";
    //     this.systemlistparms.systemName = obj[1].value;
    //   }else{
    //     this.systemlistparms.systemName = "";
    //     this.systemlistparms.systemId = obj[1].value;
    //   }
    // },
    addTable: function addTable() {
      this.ifSysEdit = false;
      this.closeSysEditFn(true);
      // this.editSysFn(obj, false)
    },
    showdeldialog: function showdeldialog() {
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.ifShowDelDialog = true;
      } else {
        this.$message({
          message: '请选择删除项',
          type: 'warning'
        });
      }
    },
    // 全选
    selectAll: function selectAll(checked) {
      var _this3 = this;
      if (checked) {
        this.tableData.forEach(function (ele) {
          _this3.$refs.multipleTable.toggleRowSelection(ele, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    // 批量删除
    delsystem: function delsystem() {
      var _this4 = this;
      this.ifShowDelDialog = false;
      this.delsystemlist = [];
      // eslint-disable-next-line array-callback-return
      this.multipleSelection.filter(function (item) {
        _this4.delsystemlist.push(item.systemId);
      });
      this.delSysFn();
    },
    // 单个删除
    confirmdel: function confirmdel(item, bool) {
      // this.showpop = false;
      if (bool) {
        this.delsystemlist = [item.row.systemId];
        this.$refs["sys-".concat(item.row.id)].doClose();
        var page = Math.ceil(this.totalpages / this.systemlistparms.pageSize); // 最大页数
        if (this.systemlistparms.pageNum === page) {
          if (this.totalpages % this.systemlistparms.pageSize === 1) {
            this.systemlistparms.pageNum > 1 ? this.systemlistparms.pageNum-- : this.systemlistparms.pageNum = 1;
          }
        }
        this.delSysFn();
      }
    },
    // 编辑系统
    editSysFn: function editSysFn(item, bool) {
      this.ifSysEdit = bool;
      // this.operationitem = item.row;
      this.$refs["sys-".concat(item.row.id)].doClose();
      this.operationitem = JSON.parse(JSON.stringify(item.row));
      this.closeSysEditFn(true);
    },
    // 编辑子系统
    editsubSysFn: function editsubSysFn(item, bool) {
      this.ifSubSysEdit = bool;
      this.$refs["subsys-".concat(item.row.id)].doClose();
      // this.selectsystem = item.row;
      this.selectsystem = JSON.parse(JSON.stringify(item.row));
      this.closeSubSysEditFn(true);
    },
    // 删除系统
    delSysFn: function delSysFn() {
      var _this5 = this;
      // this.delsystemlist.push(item.row.systemId);
      this.$API.delRequest({
        url: '/platform/systemInner/',
        data: this.delsystemlist
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '删除系统成功',
            type: 'success'
          });
          if (_this5.systemlistparms.pageNum === Math.ceil(_this5.totalpages / _this5.systemlistparms.pageSize) && (_this5.totalpages % _this5.systemlistparms.pageSize === _this5.delsystemlist.length || _this5.delChecked)) {
            _this5.systemlistparms.pageNum > 1 ? _this5.systemlistparms.pageNum-- : _this5.systemlistparms.pageNum = 1;
          }
          _this5.getsystemlist();
        }
      });
    },
    // 删除子系统
    delsubSysFn: function delsubSysFn(item, bool) {
      var _this6 = this;
      if (bool) {
        this.$refs["subsys-".concat(item.row.id)].doClose();
        this.$API.delRequest({
          url: "/platform/systemInner/systemCategory/".concat(item.row.id)
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this6.$message({
              message: '删除子系统成功',
              type: 'success'
            });
            _this6.getsystemlist();
          }
        });
      }
    },
    addSubSysFn: function addSubSysFn(item) {
      this.selectsystem = item.row;
      this.ifSubSysEdit = false;
      this.$refs["sys-".concat(item.row.id)].doClose();
      this.closeSubSysEditFn(true);
    },
    seeIdfaFn: function seeIdfaFn(item) {
      this.systemidfa = item.row.systemIdentity;
      this.$refs["sys-".concat(item.row.id)].doClose();
      this.showIdfa = true;
    },
    handleSelectionChange: function handleSelectionChange(val) {
      // let checkedCount = val.length;
      // this.delChecked = checkedCount === this.tableData.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      this.multipleSelection = val;
    },
    // 改变页面显示条数
    handleSizeChange: function handleSizeChange(val) {
      this.systemlistparms.pageSize = val;
      // this.filtratedata.pageNum = 1;
      this.getsystemlist();
    },
    // 改变页面页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.systemlistparms.pageNum = val;
      this.getsystemlist();
    },
    closeIdfaFn: function closeIdfaFn(bool) {
      this.showIdfa = bool;
    },
    cancelIdfaFn: function cancelIdfaFn() {
      this.closeIdfaFn(false);
    },
    closeSubSysEditFn: function closeSubSysEditFn(bool) {
      this.showSubSysEdit = bool;
    },
    cancelSubSysEditFn: function cancelSubSysEditFn() {
      this.closeSubSysEditFn(false);
    },
    subSysEditSubmitFn: function subSysEditSubmitFn(obj) {
      var _this7 = this;
      if (this.ifSubSysEdit) {
        obj.formData.id = this.selectsystem.id;
        obj.formData.systemId = this.selectsystem.systemId;
        this.$API.putRequest({
          url: '/platform/systemInner/systemCategory/',
          data: obj.formData
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '修改子系统成功',
              type: 'success'
            });
            _this7.getsystemlist();
          }
        });
      } else {
        obj.formData.systemId = this.selectsystem.systemId;
        this.$API.postRequest({
          url: '/platform/systemInner/systemCategory/',
          data: obj.formData
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this7.$message({
              message: '新增子系统成功',
              type: 'success'
            });
            _this7.getsystemlist();
          }
        });
      }
      this.closeSubSysEditFn(false);
    },
    sysEditSubmitFn: function sysEditSubmitFn(obj) {
      var _this8 = this;
      if (this.ifSysEdit) {
        obj.formData.id = this.operationitem.id;
        this.$API.putRequest({
          url: '/platform/systemInner/',
          data: obj.formData
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this8.$message({
              message: '修改系统成功',
              type: 'success'
            });
            _this8.getsystemlist();
          }
        });
      } else {
        this.$API.postRequest({
          url: '/platform/systemInner/',
          data: obj.formData
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this8.$message({
              message: '新增系统成功',
              type: 'success'
            });
            _this8.pageshow = false;
            _this8.systemlistparms.pageNum = _this8.totalpages % _this8.systemlistparms.pageSize === 0 ? Math.ceil(_this8.totalpages / _this8.systemlistparms.pageSize) + 1 : Math.ceil(_this8.totalpages / _this8.systemlistparms.pageSize);
            _this8.getsystemlist();
            _this8.$nextTick(function () {
              _this8.pageshow = true;
            });
          }
        });
      }
      this.closeSysEditFn(false);
    },
    closeSysEditFn: function closeSysEditFn(bool) {
      this.showSysEdit = bool;
    },
    cancelSysEditFn: function cancelSysEditFn() {
      this.closeSysEditFn(false);
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};